import React, { useState } from 'react';
import { colors } from 'ui/theme';

export const HeatmapTooltip = ({ x, y, text, urlKey }) => {
  const [opacity, setOpacity] = useState(0.6);

  return (
    <React.Fragment>
      <polygon
        onMouseEnter={() => setOpacity(1)}
        onMouseLeave={() => setOpacity(0.6)}
        fill={colors.green100}
        fillOpacity={opacity}
        stroke={colors.grey80}
        strokeWidth={2}
        id={urlKey}
        points={[
          x - 50,
          y + 10,
          x - 50,
          y + 30,
          x + 50,
          y + 30,
          x + 50,
          y + 10,
          x + 10,
          y + 10,
          x,
          y,
          x - 10,
          y + 10,
        ].join(',')}
      />
      <text
        x={x - 20 - Math.ceil(text.length * 0.66)}
        y={y + 25}
        fill={colors.white}
        onMouseEnter={() => setOpacity(1)}
        onMouseLeave={() => setOpacity(0.6)}
      >
        {text}
      </text>
    </React.Fragment>
  );
};
